<template>
  <div class="exhibition-dom">
    <NavHeaderBar :title="detail.title" :onClickRight="onClickRight" rightArrow />
    <div class="content">
      <van-sticky v-if="detail.introductionVideo">
        <div id="dplayer"></div>
      </van-sticky>
      <div v-if="detail.introductionPic">
        <img width="100%" :src="detail.introductionPic" />
      </div>
    </div>
  </div>
</template>

<script>
import { queryGetExhibitionDetail } from "@/config/user";
import { getEnv } from "@/config/utils";
import share from "@/mixins/share";
import DPlayer from "dplayer";
import { Toast } from "vant";
export default {
  name: "Exhibition",
  mixins: [share],
  data: function () {
    return {
      detail: {
        introductionVideo: "",
        introductionPic: "'",
        title: ""
      },
      player: ""
    };
  },

  mounted: function () {
    this.init();
  },
  methods: {
    init() {
      queryGetExhibitionDetail(this.$route.query.id).then(result => {
        if (result.success == "ok") {
          this.detail = result.data;
          document.title = result.data.projectTitle;
          this.loadPlayer();
          if (getEnv() !== "h5" && result.success == "ok") {
            const { shareimg, sharedesc, projectTitle, title } = result.data;
            this.onShare({
              link:
                window.location.href.split("?")[0] +
                "?id=" +
                this.$route.query.id + "&source=" + this.$route.query.source + "&project=" + this.$route.query.project + "&isConference=" + this.$route.query.isConference,
              title: projectTitle + title,
              imgUrl: shareimg,
              desc: sharedesc
            });

            document.addEventListener("WeixinJSBridgeReady", this.playerPlay);
          }
        } else {
          Toast.fail(result?.msg);
        }
      });
    },

    playerPlay() {
      setTimeout(() => {
        this.player.play();
      }, 500);
    },

    onClickRight() {
      const { project, source } = this.$route.query;

      if (source && (source != 'undefined')) {
        this.$router.push({
          path: "/" + source,
          query: { project: project }
        });
        return;
      }

      // if (isConference) {
      //   this.$router.replace({
      //     path: isConference ? "/conference" : "/livehome",
      //     query: { [isConference ? "code" : "project"]: project }
      //   });
      // }


      this.$router.replace({
        path: "/conference",
        query: { code: project }
      });


    },

    loadPlayer() {
      const { introductionVideo } = this.detail;
      if (introductionVideo) {
        this.$nextTick(() => {
          this.player = new DPlayer({
            container: document.getElementById("dplayer"),
            video: {
              url: introductionVideo.replace("http", "https"),
            },
            autoplay: true,
          });

          // setTimeout(() => {
          //   // let btnPlay = document.getElementsByClassName("dplayer-mobile-play");
          //   // btnPlay[0].remove();
          // }, 500);

        });
      }
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player?.destroy();
      document.title = "药大咖";
      window.removeEventListener("WeixinJSBridgeReady", this.playerPlay);
    }
  },
};
</script>

<style lang="scss" scoped>
.exhibition-dom {
  padding-top: 46px;
  background-color: #ededed;

  .content {
    #dplayer {
      position: relative;
      width: 100vw;
      height: 56.25vw;
    }
  }
}
</style>
